import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import styles from "./ModalItem.module.scss";
import { useSelector } from "redux/hooks";

import { IChatModel } from "redux/actions";
import classNames from "classnames";
import { CreditsIcon } from "../icons";
import { BestForTages } from "../BestForTags/BestForTags";
import { ModelDetails } from "../ModelDetails/ModelDetails";
import { useWindowSize } from "hooks/useWindowSize";

interface IProps {
  chatModel: IChatModel;
  selectedModel: IChatModel;
  onSelectModal: (chatModel: IChatModel) => void;
}

export const ModalItem = ({
  chatModel,
  selectedModel,
  onSelectModal,
}: IProps) => {
  const { theme } = useSelector((state) => state.authReducer);
  const { width } = useWindowSize();

  const hasWebSearch = useMemo(() => {
    const modalities = chatModel.attributes?.supported_modalities
      ?.split(",")
      .map((m) => m.trim().toLowerCase());

    return modalities?.includes("web-search") ?? false;
  }, [chatModel.attributes?.supported_modalities]);

  return (
    <div
      data-testid="gpt-confirm-model"
      className={`${classNames(styles.container, {
        [styles.light]: theme === "light",
        [styles.dark]: theme === "dark",
        [styles.active]: chatModel?.model ===  selectedModel?.model
      })} hover:cursor-pointer`}
      onClick={() => onSelectModal(chatModel)}
    >
      <div className={`${width <= 576 ? "flex flex-col gap-1" : ""} `}>
        {width <= 576 &&
          (!chatModel?.type?.includes("image") ||
            chatModel?.type?.includes("image_chat")) && (
            <div className="flex items-center gap-2 font-inter justify-end">
              <CreditsIcon />
              <div className={styles.modelCreditPerQuery}>
                <FormattedMessage
                  id={
                    chatModel.credits_per_message === 1
                      ? "gptModal.credit"
                      : "gptModal.credits"
                  }
                  values={{ credits: chatModel.credits_per_message }}
                />
              </div>
            </div>
          )}
        <div className={styles.section1}>
          <div className={styles.imageContainer}>
            <img
              className={chatModel.name === "flux-schnell" ? styles.image : ""}
              src={chatModel.image_url}
            />
          </div>
          <div className={styles.textContainer}>
            <div className="flex items-center justify-between w-full font-inter">
              <div
                className={`flex items-center ${width <= 576 ? "gap-[8px]" : "gap-[18px]"}`}
              >
                <div
                  className={classNames(styles.modalName, {
                    [styles.light]: theme === "light",
                    [styles.dark]: theme === "dark",
                  })}
                >
                  {chatModel.name}
                </div>
                {hasWebSearch && (
                  <div
                    className={`bg-[#EDF4FE] px-[6px] py-[2px] rounded-[4px] text-[#2563EB] font-inter font-medium ${width <= 576 ? "text-[11px]" : "text-[12px]"}`}
                  >
                    <FormattedMessage id="gptmodel.filterbadges.4" />
                  </div>
                )}
              </div>
              {/* {width > 576 && 
            (chatModel?.type?.includes("image") && !chatModel?.type?.includes("image_chat")) ? null : (
              <div className="flex items-center gap-2 font-inter">
                <CreditsIcon />
                <div className={styles.modelCreditPerQuery}>
                  <FormattedMessage
                    // id="gptModal.credits"
                    id={chatModel.credits_per_message === 1 ? "gptModal.credit" : "gptModal.credits"}
                    values={{ credits: chatModel.credits_per_message }}
                  />
                </div>
              </div>
            )} */}

              {width > 576 &&
                (!chatModel?.type?.includes("image") ||
                  chatModel?.type?.includes("image_chat")) && (
                  <div className="flex items-center gap-2 font-inter">
                    <CreditsIcon />
                    <div className={styles.modelCreditPerQuery}>
                      <FormattedMessage
                        id={
                          chatModel.credits_per_message === 1
                            ? "gptModal.credit"
                            : "gptModal.credits"
                        }
                        values={{ credits: chatModel.credits_per_message }}
                      />
                    </div>
                  </div>
                )}
            </div>
            <div className="flex items-center gap-1 font-inter">
              <div
                className={classNames(styles.description, {
                  [styles.light]: theme === "light",
                  [styles.dark]: theme === "dark",
                })}
              >
                {chatModel?.attributes?.provider}
              </div>
              <div
                className={classNames(styles.description, {
                  [styles.light]: theme === "light",
                  [styles.dark]: theme === "dark",
                })}
              >
                .
              </div>
              <div
                className={classNames(
                  "italic",
                  styles.description,
                  {
                    [styles.light]: theme === "light",
                    [styles.dark]: theme === "dark",
                  },
                  width < 400 && "truncate max-w-[125px]"
                )}
              >
                {chatModel?.attributes?.short_description}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={classNames(styles.separator, {
          [styles.light]: theme === "light",
          [styles.dark]: theme === "dark",
        })}
      ></div>
      <div>
        <ModelDetails chatModel={chatModel} />
      </div>

      <div
        className={classNames(styles.separator, {
          [styles.light]: theme === "light",
          [styles.dark]: theme === "dark",
        })}
      ></div>
      <div>
        <BestForTages chatModel={chatModel} />
      </div>
    </div>
  );
};
